import React from 'react';
import { Instagram, Music2, Facebook } from 'lucide-react';
import { useOptIn } from './OptInContext';
const LOGO = 'https://cdn.magicpatterns.com/uploads/a1yEvjwPoVhmQ4vDr2ji7N/583093709_17843682975615978_7496880889785499115_n.jpg';
const socials = [{
  label: 'Instagram',
  href: 'https://instagram.com',
  Icon: Instagram
}, {
  label: 'TikTok',
  href: 'https://tiktok.com',
  Icon: Music2
}, {
  label: 'Facebook',
  href: 'https://facebook.com',
  Icon: Facebook
}];
const appLinks = [{
  label: 'Buy Tokens',
  href: 'https://app.clawplanetarcade.com/buytokens'
}, {
  label: 'Leaderboard',
  href: 'https://app.clawplanetarcade.com/leaderboard'
}, {
  label: 'Account',
  href: 'https://app.clawplanetarcade.com/account'
}];
export function Footer() {
  const {
    openOptIn
  } = useOptIn();
  return <footer className="relative w-full border-t border-purple-500/30 py-12" data-id="element-9">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 text-center sm:px-6" data-id="element-10">
        <a href="#top" className="flex items-center gap-3" aria-label="Back to top" data-id="element-11">
          <img src={LOGO} alt="Claw Planet Arcade logo" className="h-12 w-12 rounded-full object-cover ring-2 ring-purple-400/70 shadow-[0_0_18px_rgba(168,85,247,0.7)]" data-id="element-12" />
          <span className="font-display text-lg font-extrabold tracking-wide text-white" data-id="element-13">
            CLAW <span className="neon-purple" data-id="element-14">PLANET</span> ARCADE
          </span>
        </a>

        <nav aria-label="App links" className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3" data-id="element-15">
          {appLinks.map(l => <a key={l.href} href={l.href} onClick={e => {
          e.preventDefault();
          openOptIn(l.href);
        }} className="font-display text-sm font-semibold uppercase tracking-wider text-purple-100/80 transition-colors hover:text-cyan-200 hover:[text-shadow:0_0_10px_rgba(34,211,238,0.8)]" data-id="element-16">
              {l.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-5" data-id="element-17">
          {socials.map(({
          label,
          href,
          Icon
        }) => <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} className="flex h-11 w-11 items-center justify-center rounded-full border border-purple-500/40 text-purple-200 transition-all hover:scale-110 hover:border-cyan-300 hover:text-cyan-200 hover:shadow-[0_0_20px_rgba(34,211,238,0.7)]" data-id="element-18">
              <Icon className="h-5 w-5" aria-hidden="true" data-id="element-19" />
            </a>)}
        </div>

        <p className="font-display text-sm text-purple-100/60" data-id="element-20">
          © {new Date().getFullYear()} Claw Planet Arcade. All rights reserved.
        </p>
      </div>
    </footer>;
}